module.exports = __webpack_public_path__ + "static/media/demaubus.6a990985.jpg";